var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "mobile-multiselect-item",
    _vm._g(
      _vm._b(
        { attrs: { "is-selected": _vm.isSelected } },
        "mobile-multiselect-item",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c("color-select-option", {
        attrs: { color: _vm.color, "is-selected": _vm.isSelected }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }